function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.5299 24.068C49.4879 24.0658 49.4459 24.0645 49.4032 24.0645C49.3605 24.0645 49.3186 24.0658 49.2766 24.068C48.3748 24.1165 47.6208 24.6775 47.3396 25.4449C47.2636 25.6527 47.2217 25.8753 47.2217 26.1076C47.2217 26.3409 47.2644 26.5649 47.3411 26.7738C47.5989 27.4739 48.252 28.0017 49.0506 28.1234C49.1655 28.1412 49.2834 28.1504 49.4032 28.1504H51.0122H51.2072C51.5609 28.1949 51.8339 28.4789 51.8339 28.8222C51.8339 29.1606 51.5693 29.441 51.2235 29.4919H50.9956H49.0412H48.0471L47.2387 30.8685H51.019C51.0492 30.87 51.0795 30.871 51.1097 30.871C51.1399 30.871 51.1698 30.87 51.2 30.8685C52.1185 30.8338 52.8902 30.2693 53.1779 29.4919C53.2557 29.2816 53.2984 29.0558 53.2984 28.8208C53.2984 28.5857 53.2557 28.3607 53.1782 28.1504C52.9182 27.4466 52.2609 26.9172 51.457 26.7968C51.381 26.7854 51.3043 26.7777 51.226 26.7738C51.1875 26.7717 51.1486 26.7706 51.1096 26.7706C51.0704 26.7706 51.0318 26.7717 50.9928 26.7738H49.5324H49.2735C48.9371 26.7165 48.6813 26.4407 48.6813 26.1087C48.6813 25.7784 48.9345 25.5037 49.2694 25.445H49.5369H51.4664H52.4612L53.2696 24.068H49.5299V24.068Z",
  fill: "white",
  fillOpacity: 0.9
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.56055 24.0684H10.2345V29.3872H14.3318V30.8664H8.56057V24.0684H8.56055Z",
  fill: "white",
  fillOpacity: 0.9
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6463 24.0732L25.1054 24.9695L26.4693 27.5128L28.4241 24.0732H30.1902L26.4693 30.8612L22.8379 24.0732H25.6463Z",
  fill: "white",
  fillOpacity: 0.9
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M42.8279 27.2944C43.0255 27.2944 43.1956 27.2173 43.3385 27.0417C43.4813 26.8665 43.5528 26.6421 43.5528 26.3678C43.5528 26.0874 43.4711 25.8644 43.3079 25.6983C43.1446 25.533 42.9673 25.4499 42.7772 25.4499H40.6958V27.3047V28.6721V30.8612H39.0215V24.0732H42.8895C43.2296 24.0732 43.5441 24.1402 43.8336 24.2739C44.1228 24.4077 44.3729 24.5833 44.5839 24.7999C44.7948 25.0166 44.9599 25.2619 45.079 25.5359C45.198 25.8102 45.2577 26.0874 45.2577 26.3677C45.2577 26.578 45.2302 26.7804 45.1761 26.9751C45.1217 27.1691 45.0434 27.3525 44.941 27.5245C44.839 27.6966 44.715 27.8512 44.5687 27.9883C44.4221 28.1256 44.2573 28.2417 44.0736 28.3372L45.6659 30.8612H43.7777L41.4226 27.2944H42.8279Z",
  fill: "white",
  fillOpacity: 0.9
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M21.341 29.4845V30.8612H16.2471V24.0732H21.2491V25.4499H17.9211V26.7692H20.7795V28.041H17.9211V29.4845H21.341V29.4845Z",
  fill: "white",
  fillOpacity: 0.9
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.9794 29.4845V30.8612H31.8857V24.0732H36.8876V25.4499H33.5601V26.7692H36.4182V28.041H33.5601V29.4845H36.9794V29.4845Z",
  fill: "white",
  fillOpacity: 0.9
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M60.1761 29.4845V30.8612H55.082V24.0732H60.0842V25.4499H56.7563V26.7692H59.6144V28.041H56.7563V29.4845H60.1761V29.4845Z",
  fill: "white",
  fillOpacity: 0.9
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M3.70227 29.4785C2.51624 29.4785 1.55491 28.578 1.55491 27.4675C1.55491 26.3568 2.51624 25.4566 3.70227 25.4566C4.31172 25.4566 4.86069 25.6952 5.2515 26.0771L6.35097 25.0474C5.67859 24.4021 4.74107 24 3.70227 24C1.65754 24 0 25.5525 0 27.4675C0 29.3822 1.65754 30.9347 3.70227 30.9347C4.73409 30.9347 5.66633 30.5386 6.33776 29.9011L5.23826 28.871C4.84842 29.2456 4.30474 29.4785 3.70227 29.4785Z",
  fill: "white",
  fillOpacity: 0.9
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M20 0L25.0201 8.5047L28.7846 2.12554H31.2946L26.275 10.6181L30.0392 16.9965L33.8044 10.6376L40.0868 0H37.5694L31.2974 10.6322L30.0381 12.7517L28.7838 10.623L33.8047 2.11626L35.0588 0H27.5285L25.019 4.23934L23.7651 2.12093L25.0193 0H20Z",
  fill: "white",
  fillOpacity: 0.9
});

var SvgCleverseLogo = function SvgCleverseLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 31,
    viewBox: "0 0 61 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCleverseLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cleverse-logo.a0b01de8.svg";
export { ForwardRef as ReactComponent };